module.exports = __webpack_public_path__ + "img/no.2bc55b54.png";